// @ts-generator-hash: 5dbe779cd32dbf64bf21a60df0b5cf7ee8221f287cbb911feaf9b9e2078cf65e
// Generation date: 5/6/2026 8:25:52 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.StepWorkflowType
export enum StepWorkflowType {
  Phase = 0,
  Step = 1,
  None = 2,
}
